import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CanDeactivateGuard } from 'src/app/guard/can-deactivate.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'login-day-labor',
    loadChildren: () => import('./login-day-labor/login-day-labor.module').then( m => m.LoginDayLaborPageModule)
  },
  {
    path: 'sign-up',
    loadChildren: () => import('./sign-up/sign-up.module').then( m => m.SignUpPageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'sign-up-company-search',
    loadChildren: () => import('./sign-up-company-search/sign-up-company-search.module').then( m => m.SignUpCompanySearchPageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'find-id',
    loadChildren: () => import('./find-id/find-id.module').then( m => m.FindIdPageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'find-id-view',
    loadChildren: () => import('./find-id-view/find-id-view.module').then( m => m.FindIdViewPageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'find-password',
    loadChildren: () => import('./find-password/find-password.module').then( m => m.FindPasswordPageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'find-password-update',
    loadChildren: () => import('./find-password-update/find-password-update.module').then( m => m.FindPasswordUpdatePageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'notice-app',
    loadChildren: () => import('./notice-app/notice-app.module').then( m => m.NoticeAppPageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'notice-app-detail',
    loadChildren: () => import('./notice-app-detail/notice-app-detail.module').then( m => m.NoticeAppDetailPageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'change-password',
    loadChildren: () => import('./change-password/change-password.module').then( m => m.ChangePasswordPageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'change-phone',
    loadChildren: () => import('./change-phone/change-phone.module').then( m => m.ChangePhonePageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'banner-detail',
    loadChildren: () => import('./banner-detail/banner-detail.module').then( m => m.BannerDetailPageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'sign-out',
    loadChildren: () => import('./sign-out/sign-out.module').then( m => m.SignOutPageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'splash',
    loadChildren: () => import('./splash/splash.module').then( m => m.SplashPageModule),
    canDeactivate: [CanDeactivateGuard]
  },
]

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ]
})
export class CommonRoutingModule { }
